import { Directive, EventEmitter, HostListener, Input, OnDestroy, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { ReferenceDataLabels } from '../../constants/reference-data-labels';

const ESCAPE_KEY_CODE = 27;

@Directive()
export class BaseConfirmationDialogComponent<T> implements OnDestroy {
  @Input() public opened: boolean;
  @Input() public titleLabel: string;
  @Input() public confirmationLabel: string;
  @Input() public confirmationButtonLabel: string;
  @Input() public data: T;
  @Output() public readonly openedChange = new EventEmitter<boolean>();
  @Output() public readonly confirmAction = new EventEmitter<T>();

  public referenceDataLabels = ReferenceDataLabels;

  protected readonly destroySubject$ = new Subject();

  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent): void {
    if (event.keyCode === ESCAPE_KEY_CODE) {
      this.close();
    }
  }

  public confirm(): void {
    this.confirmAction.emit(this.data);
    this.close();
  }

  public confirmWithOutClosing(): void {
    this.confirmAction.emit(this.data);
  }

  public close(): void {
    this.opened = false;
    this.openedChange.emit(this.opened);
  }

  public ngOnDestroy(): void {
    this.destroySubject$.next();
    this.destroySubject$.complete();
  }
}
